import script from "./AlliedCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlliedCard.vue?vue&type=script&setup=true&lang=ts"

import "./AlliedCard.vue?vue&type=style&index=0&id=4d4d5d3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d4d5d3a"]])

export default __exports__